import { FC, Fragment } from "react";
import { Restaurant } from "../Restaurant/Restaurant";

export const TheWedding: FC = () => {
  return (
    <Fragment>
      <div className="section-divider-top-1 off-section"></div>

      <div className="container">
        <div className="row">
          <div className="col-sm-12">
            <h1 className="section-title light">Invitation</h1>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12 col-lg-10 offset-lg-1 col-xl-8 offset-xl-2 center">
            <div
              className="invite neela-style"
              data-animation-direction="from-left"
              data-animation-delay="100"
            >
              <span className="h-lines"></span>
              <span className="v-lines"></span>
              <div className="invite_title">
                <div className="text">
                  Save<small>the</small>Date
                </div>
              </div>

              <div className="invite_info" style={{ zIndex: 1 }}>
                <h2>
                  Andrii <small>&</small> Anastasiia
                </h2>

                <div className="uppercase">
                  Request the honor of your presence on their wedding day
                </div>
                <div className="date">
                  May 29, 2025<small>at 04:00 PM</small>
                </div>
                <div className="uppercase">
                  <Restaurant />
                </div>

                <h5>Reception to follow</h5>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
